<template>
    <!-- loading状态 -->
    <div class="spinner" >
        <template v-for="(item, index) in 3">
            <div class="centeritem"></div>
        </template>
    </div>
</template>

<script setup lang="ts">

</script>

<style lang="less" scoped>
.spinner {
    width: 100%;
    height: 60px;
    // background:wheat;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(0, 255, 224, 1);
    font-weight: bold;
    font-size: 20px;

    .centeritem {
        width: 10px;
        height: 15px;
        background: rgba(0, 255, 224, 1);
        margin: 2px;
        // border-radius: 50%;
        border-radius: 3px;
        animation: stretchdelay 1s infinite ease-in-out;
    }

    .centeritem:nth-child(1) {
        animation-delay: 0;
    }

    .centeritem:nth-child(2) {
        animation-delay: -1.1s;
    }

    .centeritem:nth-child(3) {
        animation-delay: -1.2s;
    }

    .centeritem:nth-child(4) {
        animation-delay: -1.3s;
    }

    .centeritem:nth-child(5) {
        animation-delay: -1.4s;
    }

    @keyframes stretchdelay {
        0% {
            transform: scale(1);
            opacity: 1;
        }

        20% {
            transform: scale(0.5);
            opacity: 0.5;
        }

        100% {
            transform: scale(1);
            opacity: 1;
        }
    }
}
</style>